import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { config } from '../../../../config/config';
import { UpdateCityCommand } from '../../../commands/hub/update.city.command';
import { HubFeed } from '../../../models/hub/hub.feed';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { EditCityModalActions } from './edit.city.modal.provider';

@Component({
  templateUrl: './edit.city.modal.component.html',
  styleUrls: ['./edit.city.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditCityModalComponent extends BaseComponent {
  public feed: HubFeed;
  public updateCityCommand = new UpdateCityCommand();
  public hubName: string;
  public cityForm: FormGroup;
  public selectedImageData: string;
  public selectedImageFile: File;
  public imageLink: string;
  public sizeLimit = config.eventImageSizeLimit;
  @ViewChild('imageSelector') public imageSelector: ElementRef;
  @ViewChild('img') public imgEle: ElementRef;
  @ViewChild('mask') public mask: ElementRef;
  @ViewChild('upload') public upload: ElementRef;
  @ViewChild('icon') public icon: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<EditCityModalComponent>,
    private actions: EditCityModalActions,
    private hubApiService: HubApiService,
    public imageService: ImageService,
    private formBuilder: FormBuilder,
    data: HubFeed
  ) {
    super();
    this.feed = Object.assign({}, data);
    this.selectedImageData = imageService.imageSourceUrl(this.feed.cityImage, false);
    this.createForm();
  }

  public async onImageChange($event) {
    this.selectedImageFile = $event.srcElement.files[0];

    if (!!this.selectedImageFile) {
      //if (this.selectedImageFile.size <= this.sizeLimit) {
      let reader = new FileReader();

      reader.onload = (e) => {
        this.selectedImageData = e.target['result']
          ? e.target['result'].toString()
          : null;
      };

      reader.readAsDataURL(this.selectedImageFile);
      this.selectedImageFile = await this.imageService.compressImageFile(this.selectedImageFile);
      // } else {
      //     window.alert('This image is too large!');
      //     this.imageSelector.nativeElement.value = '';
      // }
    }
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public async confirm(event: ButtonTriggerEvent) {
    if (this.selectedImageFile) {
      this.updateCityCommand.image = this.selectedImageFile;
    }
    this.updateCityCommand.cityTitle = this.feed.cityTitle;
    this.updateCityCommand.id = this.feed.id;

    this.hubApiService.updateCity(this.feed.hubName, this.updateCityCommand).subscribe((image) => {
      if (image) {
        this.actions.confirm(event, {
          image: image.imageFileName,
          cityTitle: this.feed.cityTitle,
        });
      } else {
        this.actions.confirm(event, { cityTitle: this.feed.cityTitle });
      }
      this.dialogRef.close();
    });
  }

  private createForm() {
    this.cityForm = this.formBuilder.group({
      title: [null, []],
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.city.modal/edit.city.modal.component.ts